import NotificationPopup from './NotificationPopup'

export default NotificationPopup
